import { Flex, Loader, RadioBox, Text } from 'components/ui';
import { useMarketplaceConfig } from 'hooks/use-marketplace-config';
import { OrgNetworks } from 'lib/api/generated';
import { getHeadNetworks, getMyNetworks } from 'lib/marketplace-utils';
import { useStore } from 'lib/store';
import { useRouter } from 'next/router';
import React, { SetStateAction } from 'react';
import styled from 'styled-components';
import { globalTheme } from 'styles/global-theme';

type Props = {
  networks?: string[];
  setNetworks: React.Dispatch<SetStateAction<string[]>>;
  selectedNetworks?: OrgNetworks[];
};

const FlexWrapper = styled.div`
  display: flex;
  gap: ${globalTheme.space[1]};
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

const HeadingText = styled(Text)`
  text-align: center;
  margin-bottom: ${globalTheme.space[1]};
  font-weight: bold;
`;

const CRadioBox = styled(RadioBox)``;

const NotifyNetworkComponent = ({
  networks,
  setNetworks,
  selectedNetworks,
}: Props) => {
  const router = useRouter();
  const activeorgId = useStore((store) => store.activeBuyerOrgId);
  const { id } = router.query;
  const isNew = id === 'new';

  const { data: marketplaceConfig, isLoading: isMarketplaceConfigLoading } =
    useMarketplaceConfig();

  if (isMarketplaceConfigLoading) {
    return <Loader />;
  }
  return (
    <>
      {marketplaceConfig && !!marketplaceConfig.networks.length && (
        <div>
          <FlexWrapper>
            {!!getMyNetworks(selectedNetworks, activeorgId as string)
              .length && (
              <Flex direction='column' justifyContent='center'>
                <HeadingText textAlign='center' fontSize={3}>
                  Networks you've created
                </HeadingText>
                <FlexWrapper>
                  {getMyNetworks(selectedNetworks, activeorgId as string).map(
                    (network, idx) => (
                      <CRadioBox
                        key={idx}
                        checkbox
                        label={network.name}
                        value={network.id}
                        disabled={!networks?.includes(network.id)}
                        onChange={(event) => {
                          const { checked, value } = event.target;
                          setNetworks((prev) => {
                            if (checked) {
                              // Add the value to the array if checked
                              return [...prev, value];
                            } else {
                              // Remove the value from the array if unchecked
                              return prev.filter(
                                (networkId) => networkId !== value
                              );
                            }
                          });
                        }}
                      />
                    )
                  )}
                </FlexWrapper>
              </Flex>
            )}
            {!!getHeadNetworks(selectedNetworks).length && (
              <>
                <HeadingText fontSize={3}>
                  Networks you've been added to
                </HeadingText>
                {getHeadNetworks(selectedNetworks).map((network, idx) => (
                  <CRadioBox
                    key={idx}
                    checkbox
                    label={network.name}
                    value={network.id}
                    disabled={!networks?.includes(network.id)}
                    onChange={(event) => {
                      const { checked, value } = event.target;
                      setNetworks((prev) => {
                        if (checked) {
                          // Add the value to the array if checked
                          return [...prev, value];
                        } else {
                          // Remove the value from the array if unchecked
                          return prev.filter(
                            (networkId) => networkId !== value
                          );
                        }
                      });
                    }}
                  />
                ))}
              </>
            )}
          </FlexWrapper>
        </div>
      )}
    </>
  );
};

export default NotifyNetworkComponent;
